var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('ContractWrapper',[_c('ContractLocale',{staticClass:"no-print"}),_vm._v(" "),_c('Header'),_vm._v(" "),_c('Parties'),_vm._v(" "),_c('Agreement'),_vm._v(" "),_c('ConfidentialInfo'),_vm._v(" "),_c('SupplierObligations'),_vm._v(" "),_c('ContractDuration'),_vm._v(" "),_c('Violation'),_vm._v(" "),_c('ApplicableLaw'),_vm._v(" "),_c('Signature')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/hemmelig/components/contract/Contract.vue?vue&type=template&id=d71d3b14&
// module id = null
// module chunks = 